export function generateSecureString(length = 14) {
  const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const lowercase = 'abcdefghijklmnopqrstuvwxyz';
  const numbers = '0123456789';
  const symbols = '!@#$%^&*()_+[]{}|;:,.<>?';

  function getRandomChar(str) {
    return str[Math.floor(Math.random() * str.length)];
  }

  const result = [getRandomChar(uppercase), getRandomChar(lowercase), getRandomChar(numbers), getRandomChar(symbols)];

  const allChars = uppercase + lowercase + numbers + symbols;
  while (result.length < length) {
    result.push(getRandomChar(allChars));
  }

  return result.sort(() => Math.random() - 0.5).join('');
}
